// origin may or may not have the "/" at the end. if it isn't there, we append it
export const addSlashToOriginPath = (origin: string): string => {
  return origin.slice(-1) === '/' ? origin : `${origin}/`;
};
